/**
 * ID Generation utility
 *
 * Provides unique identifiers for messages, subscriptions, and internal objects.
 */

import { createGuid } from '@bizfirst/common-js';
export { createGuid };

/**
 * Generate a cryptographically random UUID v4
 * Used for envelope IDs, subscription IDs, etc.
 *
 * @returns UUID v4 string
 */
export function generateId(): string {
  return createGuid();
}

/**
 * Generate a prefixed ID for easier debugging
 *
 * @param prefix - ID prefix (e.g., 'sub', 'req', 'msg')
 * @returns Prefixed UUID (e.g., 'sub_a1b2c3d4...')
 */
export function generatePrefixedId(prefix: string): string {
  return `${prefix}_${createGuid()}`;
}

/**
 * Generate a correlation ID for tracking related messages
 * Same format as regular UUID but intended for message grouping
 *
 * @returns UUID v4 string
 */
export function generateCorrelationId(): string {
  return createGuid();
}
